import React, { useEffect, useRef, useState } from 'react'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { Form, FormControl, FormField, FormItem, FormLabel } from '@/Components/ui/form'
import { Input } from '@/Components/ui/input'
import { Button } from '@/Components/ui/button'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import BodyCard from '@/Components/BodyCard'
import HeaderCard from '@/Components/HeaderCard'
import UserService from '@/Service/UserService'
import { Eye, EyeClosed } from 'lucide-react'
import { Checkbox } from '@/Components/ui/checkbox'
import WMSSettingsService from '@/Service/WMSSettingsService'
import Loader from '@/Components/Common/Loader'

const CreateUser = () => {
    const formRef = useRef(null)
    const emailRef = useRef()
    const passwordRef = useRef()
    const navigate = useNavigate()
    const [showPassword, setShowPassword] = useState(false)
    const [roles, setRoles] = useState([])
    const [isSaving,setIsSaving]=useState(false)
    const formSchema = z.object({
        email: z
            .string({
                message: 'Email is required',
            })
            .min(1, {
                message: 'Email is required',
            }),
        username: z
            .string({
                message: 'Username is required',
            })
            .min(1, {
                message: 'Username is required',
            }),

        first_name: z
            .string({
                message: 'First Name is required',
            })
            .min(1, {
                message: 'First Name is required',
            }),
        last_name: z
            .string({
                message: 'Last Name is required',
            })
            .min(1, {
                message: 'Last Name is required',
            }),
        role: z.array(z.string()).refine((value) => value.some((item) => item), {
            message: 'You have to select at least one role.',
        }),
        middle_name: z.string().optional(),
        password: z.string().optional(),
        //    restrict _ip: z.string().optional(),
    })

    const form = useForm({
        shouldFocusError: false,
        resolver: zodResolver(formSchema),
        defaultValues: {
            email: '',
            username: '',
            first_name: '',
            last_name: '',
            role: [],
            middle_name: '',
            password: '',
        },
    })

    async function onSubmit(values) {
        try {
            setIsSaving(true)
            const resp = await UserService.createUser(values)
            if (resp.data.success) {
                setIsSaving(false)
                navigate(`/user/${resp.data.data.name}`)
            }
        } catch (err) {
            setIsSaving(false)
        }
    }

    function onError(errors, e) {
        const errorKeys = Object.keys(errors)
        if (errorKeys.length > 0 && errors[errorKeys[0]]?.message) {
            toast.error(errors[errorKeys[0]].message)
        } else {
            toast.error('Something went wrong.')
        }
    }

    const getRoles = async () => {
        try {
            const resp = await WMSSettingsService.getWmsRoles()
            if (resp.data.success && resp.data.data.length) {
                setRoles(resp.data.data)
            }
        } catch (err) {}
    }

    useEffect(() => {
        getRoles()
    }, [])

    const handleSaveClick = () => {
        if (formRef.current) {
            formRef.current.requestSubmit()
        }
    }
    return (
        <>
            <HeaderCard>
                <div className="flex justify-end items-center">
                    <div className="flex items-center justify-end gap-2">
                        <Button className="bg-primary-purpal hover:bg-primary-purpal px-4" onClick={handleSaveClick} iconType="Save" disabled={isSaving}>
                            Save {isSaving&& <Loader fullScreen={false}/>}
                        </Button>
                    </div>
                </div>
            </HeaderCard>
            <BodyCard>

                <Form {...form}>
                    <form ref={formRef} onSubmit={form.handleSubmit(onSubmit, onError)} autoComplete="off">
                        <div className="grid grid-cols-2 gap-y-3 gap-x-6">
                            <div style={{ position: 'absolute', top: '-9999px' }}>
                                <FormField
                                    control={form.control}
                                    name="tempusername"
                                    render={({ field }) => (
                                        <FormItem className="space-y-1">
                                            <FormLabel>Username</FormLabel>
                                            <FormControl>
                                                <Input
                                                    type="text"
                                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                                    placeholder="Username"
                                                    autoComplete="new-password"
                                                />
                                            </FormControl>
                                        </FormItem>
                                    )}
                                />
                                <FormField
                                    control={form.control}
                                    name="temppassword"
                                    render={({ field }) => (
                                        <FormItem className="space-y-1">
                                            <FormLabel>Password</FormLabel>
                                            <div className="relative">
                                                <FormControl>
                                                    <Input type={showPassword ? 'text' : 'password'} />
                                                </FormControl>
                                            </div>
                                        </FormItem>
                                    )}
                                />
                            </div>
                            <FormField
                                control={form.control}
                                name="email"
                               
                                ref={emailRef}
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel required={true}>Email</FormLabel>
                                        <FormControl>
                                            <Input
                                                {...field}
                                                className="shadow-none focus-visible:ring-transparent space-0 mt-0"
                                                placeholder="Email"
                                                onChange={(e) => {
                                                    field.onChange(e.target.value)
                                                }}
                                                 autoComplete="off"
                                                 autoFill="false"
                                                
                                                
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />
                            <FormField
                                control={form.control}
                                name="password"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel>Password</FormLabel>
                                        <div className="relative">
                                            <FormControl>
                                                <Input
                                                    {...field}
                                                    type={showPassword ? 'text' : 'password'}
                                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                                    placeholder="***************"
                                                    autoComplete="new-password"
                                                    name="password"
                                                />
                                            </FormControl>
                                            <div className=" absolute top-2 right-2" onClick={() => setShowPassword(!showPassword)}>
                                                {showPassword ? <EyeClosed className="text-gray-400" /> : <Eye className="text-gray-400" />}
                                            </div>
                                        </div>
                                    </FormItem>
                                )}
                            />

                            <FormField
                                control={form.control}
                                name="username"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel className="hidden">Username</FormLabel>
                                        <FormControl>
                                            <Input
                                                {...field}
                                                className="shadow-none focus-visible:ring-transparent space-0 mt-0 hidden"
                                                placeholder="Username"
                                                disabled={true}
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />
                        </div>
                        <div className="grid mt-3 grid-cols-2 gap-y-3 gap-x-6">
                            <div className="grid grid-cols-1 gap-y-3 gap-x-6">
                                <FormField
                                    control={form.control}
                                    name="first_name"
                                    render={({ field }) => (
                                        <FormItem className="space-y-1">
                                            <FormLabel required={true}>First Name</FormLabel>
                                            <FormControl>
                                                <Input
                                                    className="shadow-none focus-visible:ring-transparent space-0 mt-0"
                                                    placeholder="First Name"
                                                    {...field}
                                                    onChange={(e) => {
                                                        field.onChange(e.target.value)
                                                        let username = e.target.value + ' ' + form.getValues('last_name')
                                                        form.setValue('username', username.trim())
                                                    }}
                                                />
                                            </FormControl>
                                        </FormItem>
                                    )}
                                />
                                <FormField
                                    control={form.control}
                                    name="middle_name"
                                    render={({ field }) => (
                                        <FormItem className="space-y-1">
                                            <FormLabel>Middle Name</FormLabel>
                                            <FormControl>
                                                <Input
                                                    className="shadow-none focus-visible:ring-transparent space-0 mt-0"
                                                    placeholder="Middle Name"
                                                    {...field}
                                                />
                                            </FormControl>
                                        </FormItem>
                                    )}
                                />
                                <FormField
                                    control={form.control}
                                    name="last_name"
                                    render={({ field }) => (
                                        <FormItem className="space-y-1">
                                            <FormLabel required={true}>Last Name</FormLabel>
                                            <FormControl>
                                                <Input
                                                    className="shadow-none focus-visible:ring-transparent space-0 mt-0"
                                                    placeholder="Last Name"
                                                    {...field}
                                                    onChange={(e) => {
                                                        field.onChange(e.target.value)
                                                        let username = form.getValues('first_name') + ' ' + e.target.value
                                                        form.setValue('username', username.trim())
                                                    }}
                                                />
                                            </FormControl>
                                        </FormItem>
                                    )}
                                />
                            </div>
                            <div className="grid grid-cols-1 gap-y-3 gap-x-6">
                                {/* <FormField
                                    control={form.control}
                                    name="restrict_ip"
                                    render={({ field }) => (
                                        <FormItem className="space-y-1">
                                            <FormLabel required={true}>Restrict IP</FormLabel>
                                            <FormControl>
                                                <Textarea
                                                    className="shadow-none focus-visible:ring-transparent space-0 mt-0"
                                                    rows="4"
                                                    placeholder="Restrict IP"
                                                    {...field}
                                                ></Textarea>
                                            </FormControl>
                                        </FormItem>
                                    )}
                                /> */}
                            </div>
                        </div>
                        <div className="grid mt-5 grid-cols-1 gap-y-3 gap-x-6">
                            <FormField
                                control={form.control}
                                name="role"
                                render={() => (
                                    <FormItem className="space-y-1 flex flex-col justify-around">
                                        <FormLabel required={true} className="mb-3">
                                            User Role
                                        </FormLabel>
                                        <div className="grid grid-cols-4 gap-y-3 gap-x-6">
                                            {roles.map((item) => (
                                                <FormField
                                                    key={item.role}
                                                    control={form.control}
                                                    name="role"
                                                    render={({ field }) => {
                                                        return (
                                                            <FormItem key={item.role} className="flex flex-row items-start space-x-3 space-y-0">
                                                                <FormControl>
                                                                    <Checkbox
                                                                        checked={field.value?.includes(item.roles)}
                                                                        onCheckedChange={(checked) => {
                                                                            return checked
                                                                                ? field.onChange([...field.value, item.roles])
                                                                                : field.onChange(field.value?.filter((value) => value !== item.roles))
                                                                        }}
                                                                    />
                                                                </FormControl>
                                                                <span className="text-sm  font-light">{item.roles}</span>
                                                            </FormItem>
                                                        )
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    </FormItem>
                                )}
                            />
                        </div>
                    </form>
                </Form>
            </BodyCard>
        </>
    )
}

export default CreateUser